module.exports = __webpack_public_path__ + "img/logo-day-mobile.4792be8c.svg";